import {Component, OnInit} from '@angular/core';
import {Request} from "../../classes/request";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../services/auth";
import {HttpErrorResponse} from "@angular/common/http";
import {RequestService} from "../../services/request";
import {DocumentService} from "../../services/document";
import {Document} from "../../classes/document";
import {User} from "../../classes/user";

@Component({
    selector: 'app-request-compile',
    templateUrl: './request-compile.component.html',
    styleUrls: ['./request-compile.component.css']
})
export class RequestCompileComponent implements OnInit {
    user: User = new User();
    request: Request = new Request();
    loadingCondition: boolean = false;
    checkboxInterventionsOptions: any = [ 'Impianto Fotovoltaico', 'Formazione', 'Software' ];
    checkboxInterventionsValues: any = [ false, false, false ];
    fileName: any = {
        11: '',
        12: '',
        13: '',
        14: '',
        18: '',
        19: '',
        20: '',
        21: '',
        22: '',
        23: '',
        24: '',
        25: '',
        26: '',
        27: '',
        28: ''
    };
    fileData: any = {
        11: new FormData(),
        12: new FormData(),
        13: new FormData(),
        14: new FormData(),
        18: new FormData(),
        19: new FormData(),
        20: new FormData(),
        21: new FormData(),
        22: new FormData(),
        23: new FormData(),
        24: new FormData(),
        25: new FormData(),
        26: new FormData(),
        27: new FormData(),
        28: new FormData()
    };
    documentList: any = {
        11: [],
        12: [],
        13: [],
        14: [],
        18: [],
        19: [],
        20: [],
        21: [],
        22: [],
        23: [],
        24: [],
        25: [],
        26: [],
        27: [],
        28: []
    };
    documentTypeName: any = {
        11: 'PERIZIA_4',
        12: 'CARTA_IDENTITA_ING_4',
        13: 'CERTIFICAZIONE_EX_ANTE_5',
        14: 'CARTA_IDENTITA_ING_ENERGETICO',
        18: 'SICUREZZA_LAVORO',
        19: 'ASSICURAZIONE_ING_4',
        20: 'FATTURA_ING_4',
        21: 'ASSICURAZIONE_ING_ENERGETICO',
        22: 'FATTURA_ING_ENERGETICO',
        23: 'CERTIFICAZIONE_ESCO_EGE',
        24: 'DICHIARAZIONE_TERZIETA',
        25: 'CARTA_IDENTITA_CERT_CONTABILE',
        26: 'CERT_CONTABILE',
        27: 'FATTURA_ACQUISTO_BENE',
        28: 'CONTRATTO_LEASING'
    };

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private requestService: RequestService,
                private documentService: DocumentService) {
    }

    ngOnInit(): void {
        this.authService.isUserSignedIn()
            .subscribe({
                next: () => {
                    this.authService.getUser()
                        .subscribe({
                            next: (user: any) => {
                                this.user = user;
                            },
                            error: () => {
                                this.router.navigate(['/login']);
                            }
                        });
                },
                error: () => {
                    this.router.navigate(['/login']);
                }
            });

        this.route.paramMap.subscribe(params => {
            this.requestService.getByID(params.get('id'))
                .subscribe({
                    next: (request: Request) => {
                        this.request = request;
                        let requestInterventions = this.request.TaxCredit5Interventions?.split(',');
                        if (requestInterventions !== undefined && requestInterventions !== null) {
                            requestInterventions.forEach((requestIntervention: string) => {
                                const indexFound = this.checkboxInterventionsOptions.findIndex((checkboxInterventionOption: string) => {
                                    return checkboxInterventionOption === requestIntervention;
                                });
                                if (indexFound > -1) {
                                    this.checkboxInterventionsValues[indexFound] = true;
                                }
                            });
                        }

                        this.documentService.getAllByIDRequest(this.request.IDRequest!.toString())
                            .subscribe({
                                next: (documentList: any) => {
                                    this.documentList[11] = documentList[11];
                                    this.documentList[12] = documentList[12];
                                    this.documentList[13] = documentList[13];
                                    this.documentList[14] = documentList[14];
                                    this.documentList[18] = documentList[18];
                                    this.documentList[19] = documentList[19];
                                    this.documentList[20] = documentList[20];
                                    this.documentList[21] = documentList[21];
                                    this.documentList[22] = documentList[22];
                                    this.documentList[23] = documentList[23];
                                    this.documentList[24] = documentList[24];
                                    this.documentList[25] = documentList[25];
                                    this.documentList[26] = documentList[26];
                                    this.documentList[27] = documentList[27];
                                    this.documentList[28] = documentList[28];
                                },
                                error: (err: HttpErrorResponse) => {
                                    console.log(err);
                                }
                            });
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
    }

    uploadDocument(event: any, idDocumentType: number) {
        this.loadingCondition = true;
        const files: Array<File> = event.target.files;
        if (files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                this.fileData[idDocumentType].append('uploadFile', files[i]);
            }
            this.fileName[idDocumentType] = (files.length === 1) ? files[0].name : files.length + ' file selezionati';
        }

        this.fileData[idDocumentType].set('IDDocumentType', idDocumentType.toString());
        this.fileData[idDocumentType].set('IDRequest', this.request.IDRequest!.toString());
        this.fileData[idDocumentType].set('FKIDRequestType', this.request.FKIDRequestType!.toString());
        let fileNameParts: Array<string> = this.fileName[idDocumentType].split(".");
        this.fileData[idDocumentType].set('FilePath', this.documentTypeName[idDocumentType] + '---' +
            (this.request.customer?.VATNumber || '') + '_' + this.request.IDRequest!.toString() + '.' + fileNameParts[fileNameParts.length - 1]);

        this.documentService.create(this.fileData[idDocumentType])
            .subscribe({
                next: ((documentsCreated: any) => {
                    this.documentList[idDocumentType].push(...documentsCreated);
                    this.fileData[idDocumentType] = new FormData();
                    this.fileName[idDocumentType] = '';
                    this.loadingCondition = false;
                }),
                error: ((err: HttpErrorResponse) => {
                    console.log(err);
                    this.loadingCondition = false;
                })
            });
    }

    deleteDocument(document: Document) {
        this.loadingCondition = true;
        this.documentService.deleteRequestDocument(document.IDDocument)
            .subscribe({
                next: (() => {
                    this.documentList[document.FKIDDocumentType!] = this.documentList[document.FKIDDocumentType!].filter((currentDocument: Document) => {
                        return document.IDDocument !== currentDocument.IDDocument;
                    });
                    this.loadingCondition = false;
                }),
                error: ((err: HttpErrorResponse) => {
                    console.log(err);
                })
            });
    }

    valueChangeInterventions(interventionIndex: number) {
        this.checkboxInterventionsValues[interventionIndex] = !this.checkboxInterventionsValues[interventionIndex];
    }

    saveRequest() {
        let requestInterventions: string[] = [];
        this.checkboxInterventionsValues.forEach((checkboxInterventionValue: boolean, index: number) => {
            if (checkboxInterventionValue) requestInterventions.push(this.checkboxInterventionsOptions[index]);
        });
        this.request.TaxCredit5Interventions = requestInterventions.join(",");
        this.requestService.update(this.request)
            .subscribe({
                next: () => {
                    this.router.navigate(['/dashboard']);
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

}
